import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import OnboardingModal from "@/components/auth/OnboardingModal";

interface AuthCheckWrapperProps {
  children: React.ReactNode;
}

const AuthCheckWrapper: React.FC<AuthCheckWrapperProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [showOnboarding, setShowOnboarding] = useState(false);

  const path = location.pathname;
  const isAdminRoute =
    path.startsWith("/admin") ||
    path.startsWith("/admin-portal-2024") ||
    path.startsWith("/admin-dashboard");

  useEffect(() => {
    if (!user || isAdminRoute) {
      setShowOnboarding(false);
      return;
    }
    try {
      const flag = sessionStorage.getItem(`tm_show_onboarding_${user.id}`);
      const dismissed = localStorage.getItem(`tm_onboarded_${user.id}`);
      if (flag && !dismissed) {
        setShowOnboarding(true);
        sessionStorage.removeItem(`tm_show_onboarding_${user.id}`);
      }
    } catch {}
  }, [user, isAdminRoute]);

  return (
    <>
      {children}
      {user && !isAdminRoute && (
        <OnboardingModal
          isOpen={showOnboarding}
          userId={user.id}
          onClose={() => setShowOnboarding(false)}
        />
      )}
    </>
  );
};

export default AuthCheckWrapper;
